import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DataCollectionUI from './DataCollectionUI.js'

class DataCollectionSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // send docs to Novel Patterns
      npErrorList: null,
      npSuccessMsg: null,
      npSubmitted: false,
      npFileList: null,
      // send docs to ScoreMe
      smErrorList: null,
      smSuccessMsg: null,
      smSubmitted: false,
      // MCA collection from ScoreMe
      mcaErrorList: null,
      mcaSuccessMsg: null,
      mcaSubmitted: false,
      mcaFileList: null,
      // re-collect ITR report
      itrErrorList: null,
      itrSuccessMsg: null,
      itrSubmitted: false,
      itrFileList: null,
      // rec-collect GST report
      gstErrorList: null,
      gstSuccessMsg: null,
      gstSubmitted: false,
      gstFileList: null,
      // download files
      downloadRequested: false,
      fileErrorList: null,
      // creditAssessmentDate modal
      updateDateMode: false,
      skipCollectionModeGST: false,
      selectedSkipCollectionGST: null,
      skipCollectionModeITR: false,
      itrSkippedSuccessMsg: null,
      itrSkippedErrorList: [],
      gstSkippedSuccessMsg: null,
      gstSkippedErrorList: [],
      // re-upload bank statements
      bsErrorList: null,
      bsSuccessMsg: null,
      bsSubmitted: false,
      bsFileList: null,
      // bank stmt upload
      bsUploadMode: false,
      bsUploadErrorList: [],
      //
      deleteSubmitted: false,
      deleteMode: false,
    }
  }

  render() {
    return (
      <DataCollectionUI
        context={this.props.context}
        loan={this.props.loan}
        onRefreshClick={this.onRefreshClick}
        onCopyToClipboard={this.props.onCopyToClipboard}
        copyToClipboardText={this.props.copyToClipboardText}
        // send docs to Novel Patterns
        npErrorList={this.state.npErrorList}
        npSuccessMsg={this.state.npSuccessMsg}
        npSubmitted={this.state.npSubmitted}
        npFileList={this.state.npFileList}
        onNPSubmit={this.onNPSubmit}
        setNPErrorList={() => { }}
        // send docs to ScoreMe
        smErrorList={this.state.smErrorList}
        smSuccessMsg={this.state.smSuccessMsg}
        smSubmitted={this.state.smSubmitted}
        onSMSubmit={this.onSMSubmit}
        setSMErrorList={() => { }}
        //
        mcaErrorList={this.state.mcaErrorList}
        mcaSuccessMsg={this.state.mcaSuccessMsg}
        mcaSubmitted={this.state.mcaSubmitted}
        onMCASubmit={this.onMCASubmit}
        setMCAErrorList={() => { }}
        mcaFileList={this.state.mcaFileList}
        //
        itrErrorList={this.state.itrErrorList}
        itrSuccessMsg={this.state.itrSuccessMsg}
        itrSubmitted={this.state.itrSubmitted}
        itrFileList={this.state.itrFileList}
        onITRSubmit={this.onITRSubmit}
        //
        gstErrorList={this.state.gstErrorList}
        gstSuccessMsg={this.state.gstSuccessMsg}
        gstSubmitted={this.state.gstSubmitted}
        onGSTSubmit={this.onGSTSubmit}
        gstFileList={this.state.gstFileList}
        // creditAssessmentDate modal
        updateDateMode={this.state.updateDateMode}
        onUpdateDateClick={() => { this.setState({ updateDateMode: true }) }}
        onCancelDateClick={() => { this.setState({ updateDateMode: false }) }}
        onAccountUpdate={this.props.onAccountUpdate}
        //
        onDownloadFileClick={this.onDownloadFileClick}
        fileErrorList={this.state.fileErrorList}
        //
        onSkipCollectionITR={this.onSkipCollectionITR}
        onSkipCollectionGST={this.onSkipCollectionGST}
        skipCollectionModeGST={this.state.skipCollectionModeGST}
        selectedSkipCollectionGST={this.state.selectedSkipCollectionGST}
        skipCollectionModeITR={this.state.skipCollectionModeITR}
        itrSkippedSuccessMsg={this.state.itrSkippedSuccessMsg}
        itrSkippedErrorList={this.state.itrSkippedErrorList}
        gstSkippedSuccessMsg={this.state.gstSkippedSuccessMsg}
        gstSkippedErrorList={this.state.gstSkippedErrorList}
        // bank stmt
        bsErrorList={this.state.bsErrorList}
        bsSuccessMsg={this.state.bsSuccessMsg}
        bsSubmitted={this.state.bsSubmitted}
        bsFileList={this.state.bsFileList}
        onBSSubmit={this.onBSSubmit}
        // bank stmt upload
        bsUploadMode={this.state.bsUploadMode}
        onBSUploadClick={() => { this.setState({ bsUploadMode: true }) }}
        onBSCancelUploadClick={() => { this.setState({ bsUploadMode: false }) }}
        bsSignedUrlApi={`/api/su/accounts/${this.props.loan.accountId}/bankStatements/fileUploadSignedUrl`}
        onBSUpload={this.onBSUpload}
        bsUploadErrorList={this.state.bsUploadErrorList}
        //
        onDeleteClick={this.onDeleteClick}
        onDeleteClickCallback={this.onDeleteClickCallback}
        deleteSubmitted={this.state.deleteSubmitted}
      />
    )
  }

  componentDidMount = () => {
    let context = this.props.context
    this.getCompanyReports(context)
  }

  onNPSubmit = () => {
    let npSubmitted = this.state.npSubmitted
    if (npSubmitted)
      return

    this.setState({
      npSuccessMsg: null,
      npErrorList: [],
      npSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/creditAssesments/novelPatterns`,
      this.onNPSubmitCallback, {}
    )
  }

  onNPSubmitCallback = (response) => {
    let npErrorList = []
    response.errorList.forEach(error => {
      npErrorList.push(error.message)
    })

    this.setState({
      npSuccessMsg: response.success,
      npErrorList: npErrorList,
      npSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ npSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ npErrorList: [] })
      }, 30000)
    }
  }

  setNPErrorList = (npErrorList) => {
    this.setState({ npErrorList: npErrorList })
  }

  onSMSubmit = () => {
    let smSubmitted = this.state.smSubmitted
    if (smSubmitted)
      return

    this.setState({
      smSuccessMsg: null,
      smErrorList: [],
      smSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/creditAssesments/scoreMe`,
      this.onSMSubmitCallback, {}
    )
  }

  onSMSubmitCallback = (response) => {
    let smErrorList = []
    response.errorList.forEach(error => {
      smErrorList.push(error.message)
    })

    this.setState({
      smSuccessMsg: response.success,
      smErrorList: smErrorList,
      smSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ smSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ smErrorList: [] })
      }, 5000)
    }
  }

  setSMErrorList = (smErrorList) => {
    this.setState({ smErrorList: smErrorList })
  }

  onMCASubmit = () => {
    let mcaSubmitted = this.state.mcaSubmitted
    if (mcaSubmitted)
      return

    this.setState({
      mcaSuccessMsg: null,
      mcaErrorList: [],
      mcaSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/mca/request`,
      this.onMCASubmitCallback, {}
    )
  }

  onMCASubmitCallback = (response) => {
    let mcaErrorList = []
    response.errorList.forEach(error => {
      mcaErrorList.push(error.message)
    })

    this.setState({
      mcaSuccessMsg: response.success,
      mcaErrorList: mcaErrorList,
      mcaSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ mcaSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ mcaErrorList: [] })
      }, 5000)
    }
  }

  setMCAErrorList = (mcaErrorList) => {
    this.setState({ mcaErrorList: mcaErrorList })
  }

  onBSSubmit = () => {
    let bsSubmitted = this.state.bsSubmitted
    if (bsSubmitted)
      return

    this.setState({
      bsSuccessMsg: null,
      bsErrorList: [],
      bsSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/bankStatements/enableReupload`,
      this.onBSSubmitCallback, {}
    )
  }

  onBSSubmitCallback = (response) => {
    let bsErrorList = []
    response.errorList.forEach(error => {
      bsErrorList.push(error.message)
    })

    this.setState({
      bsSuccessMsg: response.success,
      bsErrorList: bsErrorList,
      bsSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ bsSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ bsErrorList: [] })
      }, 5000)
    }

  }

  onITRSubmit = () => {
    let itrSubmitted = this.state.itrSubmitted
    if (itrSubmitted)
      return

    this.setState({
      itrSuccessMsg: null,
      itrErrorList: [],
      itrSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/itrReport/enableReCollection`,
      this.onITRSubmitCallback, {}
    )
  }

  onITRSubmitCallback = (response) => {
    let itrErrorList = []
    response.errorList.forEach(error => {
      itrErrorList.push(error.message)
    })

    this.setState({
      itrSuccessMsg: response.success,
      itrErrorList: itrErrorList,
      itrSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ itrSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ itrErrorList: [] })
      }, 5000)
    }

  }

  getCompanyReports = (context) => {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.loan.accountId}/companyReports/files`,
      cacheKey: CacheKeys.CompanyReports(this.props.loan.accountId),
      callback: this.getCompanyReportsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCompanyReportsCallback = (response) => {
    this.setState({
      itrFileList: response.itrFileList,
      gstFileList: response.gstFileList,
      bsFileList: response.bsFileList,
      npFileList: response.npFileList,
      mcaFileList: response.mcaFileList
    })
  }

  onGSTSubmit = () => {
    let gstSubmitted = this.state.gstSubmitted
    if (gstSubmitted)
      return

    this.setState({
      gstSuccessMsg: null,
      gstErrorList: [],
      gstSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/gstReport/enableReCollection`,
      this.onGSTSubmitCallback, {}
    )
  }

  onGSTSubmitCallback = (response) => {
    let gstErrorList = []
    response.errorList.forEach(error => {
      gstErrorList.push(error.message)
    })

    this.setState({
      gstSuccessMsg: response.success,
      gstErrorList: gstErrorList,
      gstSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ gstSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ gstErrorList: [] })
      }, 5000)
    }

  }

  onDownloadFileClick = (event) => {
    let fileType = event.currentTarget.getAttribute('data-type')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/companyReports/files/${fileType}/${fileName}/fileDownloadSignedUrl`,
      this.onDownloadFileClickCallback, null, null
    )
  }

  onDeleteClick = (event) => {
    if (this.state.deleteSubmitted)
      return

    let fileName = event.currentTarget.getAttribute('data-file-name')
    this.setState({ deleteSubmitted: true })
    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/bankStatements/files/${fileName}`,
      this.onDeleteClickCallback, null, null
    )
  }

  onDeleteClickCallback = response => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onSkipCollectionGST = (event) => {
    console.log("skipcollectionGST")
    let gstNumber = event.currentTarget.getAttribute('data-row-id')
    this.setState({ selectedSkipCollectionGST: gstNumber, skipCollectionModeGST: true })
    console.log(gstNumber)
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/gstReport/${gstNumber}/skipCollection`, this.onSkipCollectionGSTCallback, null, null
    )
  }

  onSkipCollectionITR = (event) => {
    console.log("skipcollectionITR")
    this.setState({ skipCollectionModeITR: true })
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/itrReport/skipCollection`, this.onSkipCollectionITRCallback, null, null
    )
  }

  onSkipCollectionGSTCallback = (response) => {
    console.log("done")
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })
    this.setState({
      gstSkippedSuccessMsg: response.success,
      gstSkippedErrorList: errorList,
      skipCollectionModeGST: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.props.onRefreshClick()
      }, 3000)
    }
  }

  onSkipCollectionITRCallback = (response) => {
    console.log("done")
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })
    this.setState({
      itrSkippedSuccessMsg: response.success,
      itrSkippedErrorList: errorList,
      skipCollectionModeITR: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.props.onRefreshClick()
      }, 3000)
    }
  }

  onDownloadFileClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onBSUpload = (fileId, fileName, fileType, fileSize) => {
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.loan.accountId}/bankStatements/validation`,
      this.onBSUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onBSUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      bsUploadErrorList: errorList,
    })

    if (response.errorList.length === 0) {
      this.onRefreshClick()
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.CompanyReports(this.props.loan.accountId))
    this.props.onRefreshClick()
  }
}

export default DataCollectionSF
